module.exports = __webpack_public_path__ + "media/components/Application/FormTags/Categories/34-5fdc982cc039d9e65eeb33aaacf9b92c.png";